import React, { useState, useEffect } from 'react';
import { SearchableSingleSelect } from '@ibinder/common-frontend';
import styled from 'styled-components';

const Container = styled.div`
  animation: identifier 350ms;
  margin-bottom: 1rem;
  @keyframes identifier {
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 80px;
    }
  }
`;

const SearchableDropDown = ({
  label,
  data,
  loading,
  selectedType,
  setSelectedType,
  type
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  function changeActiveItem(index) {
    setActiveIndex(index);

    switch (type) {
      case 'organization':
        setSelectedType((prevState) => ({
          ...prevState,
          organization: index
        }));
        break;
      case 'binders':
        setSelectedType((prevState) => ({
          ...prevState,
          binders: index
        }));
        break;
      case 'issueTemplate':
        setSelectedType((prevState) => ({
          ...prevState,
          issueTemplate: index
        }));
        break;
      case 'inspectionTemplate':
        setSelectedType((prevState) => ({
          ...prevState,
          inspectionTemplate: index
        }));
        break;
      default:
        setSelectedType(data[index]);
        break;
    }
  }

  // Reset selections if user changes organization
  useEffect(() => {
    // Check to only reset activeIndex after submit and not after repick
    if (type === 'binders' || selectedType.organization === null)
      changeActiveItem(null);
  }, [selectedType.organization]);

  return (
    <Container>
      <SearchableSingleSelect
        data-test="field-binder"
        activeKey={activeIndex}
        changeActiveItem={changeActiveItem}
        data={
          data
            ? data.map((item, i) => ({
                // Fix until issueTemplates has an identifiable value
                Value: item.name ? item.name : item.id,
                Key: i
              }))
            : []
        }
        loading={loading}
        label={label}
        dropdownText={"Select.."}
        searchPlaceholderText={`Search ${label}`}
        required={true}
      />
    </Container>
  );
};

export default SearchableDropDown;
